// ============================================
// HEDRA - Página de Produto - JavaScript
// VERSÃO SEM TABS
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  
  // ============================================
  // QUANTIDADE (+ e -)
  // ============================================
  const quantityInput = document.querySelector('.product-quantity-input');
  const decreaseBtn = document.querySelector('[data-action="decrease"]');
  const increaseBtn = document.querySelector('[data-action="increase"]');
  
  if (decreaseBtn && increaseBtn && quantityInput) {
    decreaseBtn.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
    
    increaseBtn.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
    });
  }
  
  // ============================================
  // CÁLCULO DE FRETE (básico)
  // ============================================
  const calcBtn = document.getElementById('calc-shipping');
  const cepInput = document.getElementById('shipping-cep');
  const resultsDiv = document.getElementById('shipping-results');
  
  if (calcBtn && cepInput && resultsDiv) {
    
    // Formata CEP enquanto digita
    cepInput.addEventListener('input', function(e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 5) {
        value = value.slice(0, 5) + '-' + value.slice(5, 8);
      }
      e.target.value = value;
    });
    
    // Calcula frete
    calcBtn.addEventListener('click', function() {
      const cep = cepInput.value.replace(/\D/g, '');
      
      if (cep.length !== 8) {
        resultsDiv.innerHTML = '<p style="color: var(--cds-support-error);">CEP inválido. Digite 8 dígitos.</p>';
        resultsDiv.classList.add('active');
        return;
      }
      
      // Simula cálculo (você deve integrar com SuperFrete ou API dos Correios)
      resultsDiv.innerHTML = '<p>Calculando...</p>';
      resultsDiv.classList.add('active');
      
      setTimeout(() => {
        resultsDiv.innerHTML = `
          <div style="padding: var(--cds-spacing-05); background: var(--cds-layer-01); border: 1px solid var(--cds-border-subtle-01); margin-top: var(--cds-spacing-04);">
            <p style="margin: 0 0 var(--cds-spacing-03) 0;"><strong>PAC:</strong> R$ 15,00 - Entrega em 7 dias úteis</p>
            <p style="margin: 0;"><strong>SEDEX:</strong> R$ 25,00 - Entrega em 3 dias úteis</p>
          </div>
        `;
      }, 1000);
    });
  }
  
  // ============================================
  // GALLERY DE THUMBS
  // ============================================
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImage = document.querySelector('.product-main-image');
  
  console.log('🖼️ Galeria Debug:', {
    thumbsEncontradas: thumbs.length,
    imagemPrincipal: mainImage ? 'encontrada' : 'NÃO encontrada'
  });
  
  if (thumbs.length > 0 && mainImage) {
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', function() {
        const fullUrl = this.getAttribute('data-full');
        
        console.log('👆 Thumb clicada:', fullUrl);
        
        // Remove active de todos
        thumbs.forEach(t => t.classList.remove('active'));
        
        // Adiciona active no clicado
        this.classList.add('active');
        
        // Extrai a base URL sem parâmetros de tamanho
        const baseUrl = fullUrl.split('?')[0];
        
        // Troca imagem principal
        mainImage.src = fullUrl;
        
        // Troca srcset para manter responsividade
        mainImage.srcset = `
          ${baseUrl}?width=400 400w,
          ${baseUrl}?width=600 600w,
          ${baseUrl}?width=800 800w,
          ${baseUrl}?width=1000 1000w,
          ${baseUrl}?width=1200 1200w
        `;
        
        console.log('✅ Imagem trocada com sucesso');
      });
    });
  } else {
    console.error('❌ Galeria não inicializada:', {
      thumbs: thumbs.length,
      mainImage: !!mainImage
    });
  }
  
});